export default __webpack_public_path__ + "static/media/eCSensorMoisture.f8224961.svg";